import React, {Component} from "react"
import { Navigate } from "react-router-dom";
import {store} from "../../App";
import { connect } from 'react-redux';
import { unsetLegitCall } from "../../Redux/TrackerActions";
import { setDialog, clearDialog, setToast, setLoader, clearLoader, showScreenBlocker, hideScreenBlocker } from "../../Redux/OverlayActions";
import { askForPermissionToReceiveNotifications } from '../../push-notification';
import { withTranslation } from '../../hooks/withTranslation';
import './CallView.css';

class CallView extends Component {
    constructor() {
        super();
        this.state = {
            naam: window.localStorage.getItem('naam') || '',
            gsm: window.localStorage.getItem('gsm') || '',
            email: window.localStorage.getItem('email') || '',
            aantal: '1-2',
            langskomen: '',
            langskomenOptions: [],
            motivatie: '',
            subscribe: false,
            accept: false,

            naamValid: ((window.localStorage.getItem('naam') || '') === "" ? "" : "is-valid"),
            gsmValid: ((window.localStorage.getItem('gsm') || '') === "" ? "" : "is-valid"),
            emailValid: "",
            aantalValid: "",
            langskomenValid: "",
            motivatieValid: "",
            subscribeValid: "",
            acceptValid: "",

            continuesValidation: false,

            redirectToTracker: false,
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleSubmitFailure = this.handleSubmitFailure.bind(this);
        this.handleSubmitSucces = this.handleSubmitSucces.bind(this);
        this.validateForm = this.validateForm.bind(this);
        this.postForm = this.postForm.bind(this);
        this.fillLangskomenArray = this.fillLangskomenArray.bind(this);
        this.selectAantal = this.selectAantal.bind(this);

        this.checkPermissionNotification = this.checkPermissionNotification.bind(this);
        this.watchdogTimeout = this.watchdogTimeout.bind(this);
        this.requestNotifications = this.requestNotifications.bind(this);
        this.preRequestPermissionNotifications = this.preRequestPermissionNotifications.bind(this);
        this.handlePreRequestPermissionNotificationsResponse = this.handlePreRequestPermissionNotificationsResponse.bind(this);
    }

    componentDidMount() {
        if (!this.props.legitCall) {
            store.dispatch(unsetLegitCall());
            store.dispatch(setToast({
                message: this.props.t('callPage.errors.somethingWrong', 'Er ging iets mis!'),
                theme: "error"
            }));
            this.setState({
                redirectToTracker: true,
            });
        }

        this.fillLangskomenArray();
    }

    fillLangskomenArray() {
        let time = new Date();
        time.setMinutes(Math.ceil(time.getMinutes() / 30) * 30);

        let midnight = new Date();
        midnight.setHours(0);
        midnight.setMinutes(0);
        midnight.setSeconds(0);
        midnight.setMilliseconds(0);
        midnight.setDate(midnight.getDate() + 1);

        let arr = [];
        for (;time < midnight; time = new Date(time.getTime() + 15*60000)) {
            arr.push({
                value: time.getHours()+":"+time.getMinutes()+":00",
                label: time.getHours()+"u"+(time.getMinutes() === 0 ? "00" : time.getMinutes())
            });
        }
        arr.push({ value: "23:59:00", label: "23u59" });

        this.setState({
            langskomenOptions: arr,
            langskomen: arr[0].value,
        });
    }

    selectAantal(value) {
        this.setState({ aantal: value });
        if (this.state.continuesValidation) {
            this.validateForm(false);
        }
    }

    validateForm(showToast) {
        const { t } = this.props;
        let ret = true;
        let message = t('callPage.errors.invalidForm', 'Sommige gegevens zijn niet correct ingevuld!');

        let naamValid= "is-valid";
        let gsmValid= "is-valid";
        let emailValid= "is-valid";
        let aantalValid= "is-valid";
        let langskomenValid= "is-valid";
        let motivatieValid= "is-valid";
        let subscribeValid= "is-valid";
        let acceptValid= "is-valid";

        if (this.state.naam === "") {
            naamValid = "is-invalid";
            ret = false;
        }
        if (this.state.aantal === "") {
            aantalValid = "is-invalid";
            ret = false;
        }

        if (this.state.langskomen === "") {
            langskomenValid = "is-invalid";
            ret = false;
        }

        if (this.state.gsm === "") {
            gsmValid = "is-invalid";
            ret = false;
        }

        if (this.state.email === "" && this.state.subscribe) {
            emailValid = "is-invalid";
            ret = false;
        }

        if (!this.state.accept) {
            acceptValid = "is-invalid";
            if (ret) {
                message = t('callPage.errors.acceptRequired', 'Gelieve te aanvaarden dat een oproep geen garantie is!');
            }
            ret = false;
        }

        this.setState({
            naamValid: naamValid,
            gsmValid: gsmValid,
            emailValid: emailValid,
            aantalValid: aantalValid,
            langskomenValid: langskomenValid,
            motivatieValid: motivatieValid,
            subscribeValid: subscribeValid,
            acceptValid: acceptValid,
        });

        if (!ret && showToast) {
            store.dispatch(setToast({
                message: message,
                theme: "error"
            }));
        }
        return ret;
    }

    async handleChange(event) {
        const {name, value, type, checked} = event.target;
        const target = event.target;
        let cursor = -1;

        if (target.setSelectionRange &&
            (
                type === 'text' ||
                type === 'search' ||
                type === 'password' ||
                type === 'url' ||
                type === 'tel'
            )
        ) {
            cursor = ('selectionStart' in event.target ? (event.target.selectionStart ?? -1) : -1);
        }
        await type === "checkbox" ? this.setState({ [name]: checked }) : this.setState({ [name]: value });
        if (cursor !== -1 && target.setSelectionRange) {
            target.setSelectionRange(cursor, cursor);
        }
        if (this.state.continuesValidation) {
            this.validateForm(false);
        }
    }

    handleCancel(event) {
        event.preventDefault();
        this.setState({
            redirectToTracker: true,
        });
    }

    async handleSubmit(event) {
        event.preventDefault();

        if (!this.validateForm(true)) {
            this.setState({
                continuesValidation: true,
            });
        } else {
            this.checkPermissionNotification();
        }
    }

    checkPermissionNotification() {
        const that = this;
        const isIOSDevice = !!navigator.platform.match(/iPhone|iPod|iPad/);
        if (isIOSDevice) {
            that.postForm('');
        } else {
            navigator.permissions && navigator.permissions.query({name: 'notifications'}).then(function(PermissionStatus) {
                if('granted' === PermissionStatus.state) {
                    that.requestNotifications();
                } else if('denied' === PermissionStatus.state) {
                    that.postForm('');
                } else {
                    that.preRequestPermissionNotifications();
                }
            });
            if (!navigator.permissions) {
                const geolocationState = localStorage.getItem('notifications') || '';
                if('granted' === geolocationState) {
                    that.requestNotifications();
                } else if('denied' === geolocationState) {
                    that.postForm('');
                } else {
                    that.preRequestPermissionNotifications();
                }
            }
        }
    }

    preRequestPermissionNotifications() {
        const that = this;
        const { t } = this.props;
        const productName = t('company.productName', 'IJskar');
        store.dispatch(setDialog({
            title: t('callPage.notificationDialog.title', `Wil je een melding ontvangen als de ${productName} onderweg is?`),
            message: t('callPage.notificationDialog.message', `Als je toegang tot push-meldingen toestaat, kunnen we je een notificatie sturen als de ${productName} naar jou onderweg is. Indien je dit liever niet toestaat zullen we in de plaats daarvan een SMS sturen.`),
            btn1Text: t('callPage.notificationDialog.acceptButton', 'Verwittig mij!'),
            btn1Title: "accept",
            btn1Theme: "primary",
            btn2Text: t('callPage.notificationDialog.denyButton', 'Liever niet'),
            btn2Title: "deny",
            response: that.handlePreRequestPermissionNotificationsResponse,
        }));
    }

    handlePreRequestPermissionNotificationsResponse(response) {
        store.dispatch(clearDialog());
        if (response === "accept") {
            this.requestNotifications();
        } else if (response === "deny" || response === "dismiss") {
            this.postForm((window.localStorage.getItem('token') || ''));
        }
    }

    async watchdogTimeout() {
        return new Promise(resolve => setTimeout(() => resolve({
            status: "FAIL",
            error: "Watchdog timeout"
        }), 2200));
    }

    async requestNotifications() {
        store.dispatch(showScreenBlocker());
        const permissionResponse = await Promise.race([askForPermissionToReceiveNotifications, this.watchdogTimeout].map(f => f()));
        console.log(permissionResponse);
        store.dispatch(hideScreenBlocker());

        let token = "";
        if (permissionResponse.status === "SUCCESS") {
            localStorage.setItem('notifications', "granted");
            token = permissionResponse.token;
            this.postForm(token);
        } else {
            localStorage.setItem('notifications', "denied");
            this.postForm((window.localStorage.getItem('token') || ''));
        }
    }

    postForm(token) {
        const { t } = this.props;
        store.dispatch(setLoader({
            title: t('loaders.pleaseWait', 'Even geduld...'),
            message: t('callPage.loader.placingCall', 'Je oproep wordt geplaatst'),
        }));

        window.localStorage.setItem('naam', this.state.naam);
        window.localStorage.setItem('gsm', this.state.gsm);
        window.localStorage.setItem('email', this.state.email);
        window.localStorage.setItem('token', token);

        let formData = new FormData();
        formData.append('gpslat', (window.localStorage.getItem('gpslat') || ''));
        formData.append('gpslong', (window.localStorage.getItem('gpslong') || ''));
        formData.append('latitude', (window.localStorage.getItem('latitude') || ''));
        formData.append('longitude', (window.localStorage.getItem('longitude') || ''));
        formData.append('straat', (window.localStorage.getItem('straat') || ''));
        formData.append('nr', (window.localStorage.getItem('nr') || ''));
        formData.append('gemeente', (window.localStorage.getItem('gemeente') || ''));
        formData.append('postcode', (window.localStorage.getItem('postcode') || ''));
        formData.append('land', (window.localStorage.getItem('land') || ''));
        formData.append('placeid', (window.localStorage.getItem('placeid') || ''));
        formData.append('adres', (window.localStorage.getItem('adres') || ''));
        formData.append('naam', this.state.naam);
        formData.append('gsm', this.state.gsm);
        formData.append('email', this.state.email);
        formData.append('aantal', this.state.aantal);
        formData.append('langskomen', this.state.langskomen);
        formData.append('motivatie', this.state.motivatie);
        formData.append('subscribe', this.state.subscribe);
        formData.append('available', (this.props.availableNearby) ? 1 : 0);
        formData.append('udid', (window.localStorage.getItem('udid') || ''));
        formData.append('token', token);
        formData.append('versioninfo', window.versionInfo || "");

        fetch(process.env.REACT_APP_API_HREF+"legacycopy.php?action=add_oproep",{
            method: 'POST',
            body: formData,
        }).then(function(response) {
            store.dispatch(clearLoader());
            return response.json();
        }).then(data => {
            if (data.status === 201) {
                this.handleSubmitSucces();
            } else {
                this.handleSubmitFailure();
            }
        }).catch(error => {
            this.handleSubmitFailure();
        });
    }

    handleSubmitFailure() {
        const { t } = this.props;
        store.dispatch(setToast({
            message: t('callPage.errors.submitFailed', 'Er ging iets mis bij het plaatsen van je oproep. Probeer het later opnieuw.'),
            theme: "error"
        }));
    }

    handleSubmitSucces() {
        const { t } = this.props;
        const date = new Date();
        const now = date.getTime();
        window.localStorage.setItem('lastCallTime', now);

        store.dispatch(setToast({
            message: t('callPage.success', 'Je oproep is geplaatst!'),
        }));

        this.setState({
            redirectToTracker: true,
        });
    }

    render() {
        if (this.state.redirectToTracker === true) {
            return <Navigate to='/' />
        }

        const { t } = this.props;
        const productName = t('company.productName', 'IJskar');
        const companyName = t('company.name', 'Foubert');

        const aantalOptions = [
            { value: '1-2', label: '1-2', icon: '👤' },
            { value: '3-4', label: '3-4', icon: '👥' },
            { value: '5-6', label: '5-6', icon: '👨‍👩‍👧' },
            { value: '7-8', label: '7-8', icon: '👨‍👩‍👧‍👦' },
            { value: '9-10', label: '9-10', icon: '👨‍👩‍👧‍👧' },
            { value: '10+', label: '10+', icon: '🎉' },
        ];

        return (
            <div className="call-page">
                <div className="call-header">
                    <div className="call-header-icon">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                        </svg>
                    </div>
                    <h1>{t('callPage.title', 'Oproep plaatsen')}</h1>
                    <p>{t('callPage.subtitle', `Vul de laatste gegevens in om een ${productName.toLowerCase()} tot bij jullie te roepen`)}</p>
                </div>

                <form onSubmit={this.handleSubmit} className="call-form">
                    {/* Contact Info Section */}
                    <div className="form-section">
                        <h2 className="form-section-title">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                                <circle cx="12" cy="7" r="4"/>
                            </svg>
                            {t('callPage.sections.contact', 'Contactgegevens')}
                        </h2>

                        <div className="form-field">
                            <label htmlFor="formName">{t('callPage.fields.name.label', 'Naam')}</label>
                            <input
                                type="text"
                                value={this.state.naam}
                                name="naam"
                                placeholder={t('callPage.fields.name.placeholder', 'Bv. Madame Blanche')}
                                onChange={this.handleChange}
                                id="formName"
                                className={`form-input ${this.state.naamValid}`}
                            />
                            {this.state.naamValid === "is-invalid" && (
                                <span className="field-error">{t('callPage.fields.name.error', 'Gelieve een naam in te voeren')}</span>
                            )}
                        </div>

                        <div className="form-field">
                            <label htmlFor="formCellPhone">{t('callPage.fields.phone.label', 'GSM-nummer')}</label>
                            <input
                                type="tel"
                                value={this.state.gsm}
                                name="gsm"
                                placeholder={t('callPage.fields.phone.placeholder', 'Bv. 0412 34 56 78')}
                                onChange={this.handleChange}
                                id="formCellPhone"
                                className={`form-input ${this.state.gsmValid}`}
                            />
                            {this.state.gsmValid === "is-invalid" && (
                                <span className="field-error">{t('callPage.fields.phone.error', 'Gelieve een gsm-nummer in te geven')}</span>
                            )}
                            <span className="field-hint">{t('callPage.fields.phone.hint', 'We gebruiken dit alleen om je te verwittigen')}</span>
                        </div>

                        <div className="form-field">
                            <label htmlFor="formEmail">{t('callPage.fields.email.label', 'Email (optioneel)')}</label>
                            <input
                                type="email"
                                value={this.state.email}
                                name="email"
                                placeholder={t('callPage.fields.email.placeholder', 'blanche@foubert.eu')}
                                onChange={this.handleChange}
                                id="formEmail"
                                className={`form-input ${this.state.emailValid}`}
                            />
                            {this.state.emailValid === "is-invalid" && (
                                <span className="field-error">{t('callPage.fields.email.error', 'Gelieve een geldig emailadres in te geven')}</span>
                            )}
                        </div>

                        <label className="checkbox-field">
                            <input
                                type="checkbox"
                                name="subscribe"
                                checked={this.state.subscribe}
                                onChange={this.handleChange}
                            />
                            <span className="checkbox-custom"></span>
                            <span className="checkbox-label">{t('callPage.fields.subscribe', `Schrijf me in voor de ${companyName}-nieuwsbrief!`)}</span>
                        </label>
                    </div>

                    {/* Oproep Details Section */}
                    <div className="form-section">
                        <h2 className="form-section-title">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <circle cx="12" cy="12" r="10"/>
                                <polyline points="12 6 12 12 16 14"/>
                            </svg>
                            {t('callPage.sections.details', 'Details van je oproep')}
                        </h2>

                        <div className="form-field">
                            <label>{t('callPage.fields.numberOfPeople', 'Aantal personen')}</label>
                            <div className="aantal-chips">
                                {aantalOptions.map(option => (
                                    <button
                                        type="button"
                                        key={option.value}
                                        className={`aantal-chip ${this.state.aantal === option.value ? 'selected' : ''}`}
                                        onClick={() => this.selectAantal(option.value)}
                                    >
                                        <span className="chip-icon">{option.icon}</span>
                                        <span className="chip-label">{option.label}</span>
                                    </button>
                                ))}
                            </div>
                        </div>

                        <div className="form-field">
                            <label htmlFor="formUntil">{t('callPage.fields.until.label', 'Langskomen mag tot')}</label>
                            <select
                                value={this.state.langskomen}
                                name="langskomen"
                                id="formUntil"
                                className={`form-input form-select ${this.state.langskomenValid}`}
                                onChange={this.handleChange}
                            >
                                {this.state.langskomenOptions.map((opt, idx) => (
                                    <option key={idx} value={opt.value}>{opt.label}</option>
                                ))}
                            </select>
                            {this.state.langskomenValid === "is-invalid" && (
                                <span className="field-error">{t('callPage.fields.until.error', 'Gelieve een tijdstip te kiezen')}</span>
                            )}
                        </div>

                        <div className="form-field">
                            <label htmlFor="formMotivation">{t('callPage.fields.extraInfo.label', 'Extra info (optioneel)')}</label>
                            <textarea
                                value={this.state.motivatie}
                                name="motivatie"
                                placeholder={t('callPage.fields.extraInfo.placeholder', 'Bv. Wij geven een kotfeestje!')}
                                onChange={this.handleChange}
                                rows="3"
                                className={`form-input form-textarea ${this.state.motivatieValid}`}
                                id="formMotivation"
                            />
                        </div>
                    </div>

                    {/* Confirmation Section */}
                    <div className="form-section confirmation-section">
                        <label className={`checkbox-field accept-checkbox ${this.state.acceptValid === "is-invalid" ? 'invalid' : ''}`}>
                            <input
                                type="checkbox"
                                name="accept"
                                checked={this.state.accept}
                                onChange={this.handleChange}
                            />
                            <span className="checkbox-custom"></span>
                            <span className="checkbox-label" dangerouslySetInnerHTML={{__html: t('callPage.fields.accept', `Ik begrijp dat een oproep <strong>geen garantie</strong> is dat er effectief een ${productName.toLowerCase()} langskomt`)}} />
                        </label>
                    </div>

                    {/* Action Buttons */}
                    <div className="form-actions">
                        <button type="submit" className="btn-submit">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                            </svg>
                            {t('callPage.submitButton', `Roep de ${productName}!`)}
                        </button>
                        <button type="button" className="btn-cancel" onClick={this.handleCancel}>
                            {t('callPage.cancelButton', 'Annuleer')}
                        </button>
                    </div>
                </form>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        legitCall: state.tracker.legitCall || false,
        availableNearby: state.tracker.availableNearby || false,
    }
}

export default connect(mapStateToProps)(withTranslation(CallView));
